export interface LibraryItem {
  article_id: string;
  bookmarked: boolean;
  read_at: number | null;
  updated_at?: number;
}

export function scanGuestLibrary(storage: Pick<Storage, "length" | "key" | "getItem">): LibraryItem[] {
  const items = new Map<string, LibraryItem>();
  for (let index = 0; index < storage.length; index += 1) {
    const key = storage.key(index);
    if (!key || !storage.getItem(key)) continue;
    if (key.startsWith("geo-read:")) {
      const articleId = key.slice("geo-read:".length);
      if (/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(articleId)) {
        const prior = items.get(articleId);
        items.set(articleId, { article_id: articleId, bookmarked: prior?.bookmarked ?? false, read_at: 1 });
      }
    }
    if (key.startsWith("geo-bm:")) {
      const path = key.slice("geo-bm:".length);
      const match = path.match(/\/p\/([a-z0-9]+(?:-[a-z0-9]+)*)(?:\.html)?(?:[?#]|$)/);
      const articleId = match?.[1];
      if (articleId) {
        const prior = items.get(articleId);
        items.set(articleId, { article_id: articleId, bookmarked: true, read_at: prior?.read_at ?? null });
      }
    }
  }
  return [...items.values()].sort((a, b) => a.article_id.localeCompare(b.article_id));
}

export async function importKey(items: LibraryItem[]): Promise<string> {
  const canonical = JSON.stringify(items.map(({ article_id, bookmarked, read_at }) => ({ article_id, bookmarked, read_at })));
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(canonical));
  const hex = [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, "0")).join("");
  return `guest-import:${hex}`;
}
